import { render } from "./ProductDetails.vue?vue&type=template&id=72f283fb"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"
script.render = render

export default script